module.exports = __webpack_public_path__ + "img/meeyads.46ff822e.svg";